<template>
  <div v-if="page=='home'">
    <div class="row col-md-12">
      <div class="col-md-9">
        <slot name="home"></slot>
      </div>

      <div class="col-md-4" v-if="dados.anais_cor_bg_menus == null || dados.anais_cor_bg_menus == '' || !dados.anais_cor_bg_menus">
        <div>
          <div class="box-1 pull-left">
            <div class="box-1-child">
              <div class="box-1-num" id="trabalhos_publicados">
                {{trabalhos.length}}
              </div>
              <div class="box-1-text">{{ $tc('trabalho_publicado', 2) | capitalize}}</div>
            </div>
          </div>

          <div class="box-1 pull-right">
            <div class="box-1-child">
              <div class="box-1-num" id="eixos_tematicos">
                {{eixos.length}}
              </div>
              <div class="box-1-text">{{ $tc('eixo_tematico', 2) | capitalize }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3" v-else>
        <div>
          <div class="box-1-new pull-left" :style="{background: dados.anais_cor_bg_stats, border:dados.anais_cor_bg_stats + ' solid 1px', color: dados.anais_cor_fonte_stats}">
            <div class="box-1-child-new">
              <div class="box-1-num-new" id="trabalhos_publicados">
                {{trabalhos.length}}
              </div>
              <div class="box-1-text-new">{{ $tc('trabalho_publicado', 2) | capitalize}}</div>
            </div>
          </div>

          <div class="box-1-new pull-right" :style="{background: dados.anais_cor_bg_stats, border:dados.anais_cor_bg_stats + ' solid 1px', color: dados.anais_cor_fonte_stats}">
            <div class="box-1-child-new">
              <div class="box-1-num-new" id="eixos_tematicos">
                {{eixos.length}}
              </div>
              <div class="box-1-text-new">{{ $tc('eixo_tematico', 2) | capitalize }}</div>
            </div>
          </div>

          <div class="col-md-12" v-html="dados.anais_msg_home_stats">{{dados.anais_msg_home_stats}}</div>

        </div>
      </div>

    </div>
  </div>

  <div v-else-if="page=='corpo_editorial'" class="col-md-12">
    <slot name="corpo_editorial"></slot>
  </div>

  <div v-else-if="eixos" class="col-md-12">
    <h1 id="eixos-title">{{ $tc('eixo', 2) | capitalize }}</h1>
    <ul id="eixos">
      <li v-for="e in eixos">
        <router-link :to="{name:'trabalhos', params:{pesquisa:e.nome}}">
          {{e.nome}} ({{e.trabalhos.length}})
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import Vue from 'vue'
  import removeAccents from 'remove-accents'
  import { i18n } from '@/langs/anais'

export default {
  name: 'anaisMain',
  props: {},
  components: {},
  filters: {},
  watch: {},

  data () {
    return {
      dados: {
        anais_cor_bg_menus: null
      }
    }
  },

  computed: {
    page() {
      // retorna sempre uma string da página em que estamos
      let ret = this.$route.params.page
      if(!ret) {
        return 'home'
      }
      return ret
    },

    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos() { return eixos },
    autores() { return autores },
    palavras_chaves() { return palavras_chaves },
    trabalhos() { return trabalhos },
  },
  created() {},

  mounted () {

    Promise.all([
      this.$http.post(window.url + "admin/api", {
        type: "getAnaisInfo"
      })
    ])
    .catch((err) => {
      console.log(err);
    })
    .then((responses)=>{
      let responsePromises = []
      for(let response of responses){
        responsePromises.push(response.json())
      }
      return Promise.all(responsePromises)
    }).then((responses)=>{

      this.dados = responses[0];

    })

  },

  methods: {},
  i18n: i18n
}
</script>

<style scoped>

.box-1-new {
  width:100%;
  border-radius:10px;
  text-align:center;
  padding:40px;
  margin-bottom:20px;
}

.box-1-num-new {
  font-size:55px;
  font-weight:bold;
}

.box-1-text-new {
  margin-top:20px;
}

.box-1 {
  text-align: center;
  color: white;
  padding: 0 10px;
  width: 50%;
}
.box-1-child {
  background: #A62B22;
  border-radius: 5px;
}
.box-1-text {
  padding: 15px 0;
}
.box-1-num {
  background: #B7453C;
  font-size: 42px;
  padding: 20px 0;
  border-radius: 5px 5px 0 0;
}

#eixos-title {
  text-transform: unset;
  border-bottom: 1px solid #CCC;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
#eixos {
  list-style-type: disc;
}
a {
  color: unset;
}
a:hover {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// AnaisMain.vue?44ecd859